import type { Ref } from 'vue';

export abstract class DropdownItemBase {
    /**
     * Unique key to be used in the v-for in DropdownComp.
     */
    abstract uniqueLoopKey: string;

    /**
     * Wether the dropdownitem is hidden or not
     * If this is true, the dropdownitem will not be rendered
     * The justification for this existing is that if we have a recursive dropdown, we need to hide items in the sublevels
     * That makes it difficult to mutate the list of item and then readd the items back into the parent container
     * In most cases we should probably still just remove the filtered items from the list and leave this as undefined
     */
    hideDropDownItem?: Ref<boolean>;

    markTextPart?: RegExp | string | Ref<RegExp | string | undefined>;

    /**
     * Wether the dropdownitem is disabled or not
     */
    disabled?: boolean;
}
